export type ProjectPictureId = {
  id: string;
  project: string;
}

export type ProjectPicture = {
  id: string;
  project: string;
  picture: string;
  rotation: number;
}

export type JobPictureId = {
  id: string;
  job: string;
}

export type JobPicture = {
  id: string;
  job: string;
  picture: object;
  accepted: boolean;
  order_number: number;
  rotation: number;
}

export type RoutinePictureId = {
  id: string;
  routine: string;
}

export type RoutinePicture = {
  id: string;
  special_job: string;
  picture: object;
  accepted: boolean;
  order_number: number;
  rotation: number;
};

export type SpecialJobPictureId = {
  id: string;
  special_job: string;
}

export type SpecialJobPicture = {
  id: string;
  special_job: string;
  picture: object;
  accepted: boolean;
  order_number: number;
  rotation: number;
};

export type NewJobPictureId = {
  id: string;
  new_job: string;
}

export type NewJobPicture = {
  id: string;
  new_job: string;
  picture: object;
  accepted: boolean;
  order_number: number;
  rotation: number;
};

export type ProjectOrJobPicture =
  | ProjectPicture
  | JobPicture
  | RoutinePicture
  | SpecialJobPicture
  | NewJobPicture;

export type ProjectOrJobPictureId =
  | ProjectPictureId
  | JobPictureId
  | RoutinePictureId
  | SpecialJobPictureId
  | NewJobPictureId;

export enum PictureType {
  LOGO = 'LOGO',
  JOB = 'RJ',
  ROUTINE = 'RR',
  NEWJOB = 'RN',
  SPECIALJOB = 'RS',
  PROJECT = 'PROJECT',
}
